import type { IconSvgObject } from './types';

const PhoneEraseIcon: IconSvgObject = [
  ["path", { d: "M12.5 2H8.5L9 3H12L12.5 2Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M14 9L20 15M20 9L14 15", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M17 17V20.5C17 21.3284 16.3284 22 15.5 22H5.5C4.67157 22 4 21.3284 4 20.5V3.5C4 2.67157 4.67157 2 5.5 2H15.5C16.3284 2 17 2.67157 17 3.5V7", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default PhoneEraseIcon;
